import { HoldingDepositRegister } from "../models/holdingdepositregister.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getHoldingDepositRegister = (): Promise<HoldingDepositRegister[]> => {
    return new Promise<HoldingDepositRegister[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/humandc/holdingdepositregister`).then((response) => {
            resolve(response.data as HoldingDepositRegister[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};